module.exports = __webpack_public_path__ + "img/portfolio.59ba7612.svg";